export const jobNumberSalt = "4UVte4rzrR31UGccc9SZ";
